import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentSubdomain } from './hostContext';
import AdminSettings from '../components/AdminHeader';

/**
 * Layout route element that gates its children behind a required subdomain.
 *
 * Behavior parity with the previous inline `SubdomainRoute`:
 *   - If the current subdomain does not match, redirect to "/".
 *   - Otherwise, render `<AdminSettings />`, which contains its own `<Outlet />`
 *     where the matched child route renders.
 *
 * In Phase D this element will be paired with a route loader
 * (`requireAdminSubdomain`) that performs the redirect *before* the element
 * mounts, eliminating any flash of gated content.
 */
const SubdomainGate = ({ requiredSubdomain }) => {
    if (getCurrentSubdomain() !== requiredSubdomain) {
        return <Navigate to="/" replace />;
    }
    return <AdminSettings />;
};

export default SubdomainGate;
